<template>
  <div>
    <!-- vueCropper 剪裁图片实现-->
    <el-dialog
      :title="props_dialogTitle"
      :visible.sync="dialogVisible"
      top="5vh"
      width="90%"
      append-to-body
      :fullscreen="true"
    >
      <div class="cropper-content">
        <div class="cropper">
          <vue-cropper
            ref="cropper"
            :img="img"
            :output-size="props_size"
            :output-type="props_outputType"
            :info="props_info"
            :aspect-ratio="props_aspect_ratio"
            :full="props_full"
            :fixed="props_fixed"
            :fixed-number="props_fixedNumber"
            :can-move="props_canMove"
            :can-move-box="props_canMoveBox"
            :fixed-box="props_fixedBox"
            :original="props_original"
            :auto-crop="props_autoCrop"
            :auto-crop-width="props_autoCropWidth"
            :auto-crop-height="props_autoCropHeight"
            :center-box="props_centerBox"
            :high="props_high"
            :mode="props_mode"
            :infoTrue="props_infoTrue"
            :canScale="props_canScale"
          >
          </vue-cropper>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">{{$t('common.ImgCropper.footer')}}</el-button>
        <el-button type="primary" @click="finish" :loading="loading"
          >{{$t('common.ImgCropper.primary')}}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    props_img: { Type: String, default: "" }, // 裁剪图片的地址
    props_aspect_ratio: { Type: Number, default: 1 }, // 裁剪图片的地址
    props_size: { Type: Number, default: 1 }, // 裁剪生成图片的质量
    props_full: { Type: Boolean, default: true }, // 输出原图比例截图 props名full
    props_outputType: { Type: String, default: "jpeg" }, // 裁剪生成图片的格式
    props_canMove: { Type: Boolean, default: false }, // 上传图片是否可以移动
    props_fixedBox: { Type: Boolean, default: true }, // 固定截图框大小 不允许改变
    props_original: { Type: Boolean, default: false }, // 上传图片按照原始比例渲染
    props_canMoveBox: { Type: Boolean, default: true }, // 截图框能否拖动
    props_autoCrop: { Type: Boolean, default: true }, // 是否默认生成截图框
    props_autoCropWidth: { Type: Number, default: 120 }, // 只有自动截图开启 宽度高度才生效
    props_autoCropHeight: { Type: Number, default: 120 }, // 默认生成截图框高度
    props_centerBox: { Type: Boolean, default: true }, // 截图框是否被限制在图片里面
    props_high: { Type: Boolean, default: true }, // 是否按照设备的dpr 输出等比例图片
    props_fixed: { Type: Boolean, default: true }, // 是否开启截图框宽高固定比例
    props_fixedNumber: {
      Type: Array,
      default: function () {
        return [1, 1];
      },
    }, // 截图框的宽高比例
    props_info: { Type: Boolean, default: true }, // 裁剪框的大小信息
    props_canScale: { Type: Boolean, default: false }, // canScale 图片是否允许滚轮缩放
    props_infoTrue: { Type: Boolean, default: false }, // infoTrue  true 为展示真实输出图片宽高 false 展示看到的截图框宽高:
    props_maxImgSize: { Type: Number, default: 2000 }, // maxImgSize  限制图片最大宽度和高度
    props_enlarge: { Type: Number, default: 1 }, // enlarge 图片根据截图框输出比例倍数
    props_mode: { Type: String, default: "contain" }, // mode  图片默认渲染方式
    props_dialogTitle: { Type: String, default: "圖片剪裁" },
  },
  data() {
    return {
      dialogVisible: false,
      // 裁剪图片的地址
      img: this.props_img,
      //防止多次提交
      loading: false,
    };
  },
  created(){
    // console.log(this.props_aspect_ratio);
  },
  methods: {
    initData(file) {
      this.img = window.URL.createObjectURL(file.raw);
      let test = new Image();
      test.src = window.URL.createObjectURL(file.raw);
      test.onload = function () {
        // 打印
        console.log("width:" + test.width + ",height:" + test.height);
      };
    },
    setDialogVisible(isShow) {
      this.dialogVisible = isShow;
    },
    // 点击裁剪，这一步是可以拿到处理后的地址
    finish() {
      this.loading = true;
      this.$refs.cropper.getCropBlob((data) => {
        //this.$emit("cropperConfirm", window.URL.createObjectURL(data));
        this.$emit("cropperConfirm", data);
      });
      this.loading = false;
    },
    cancel() {
      this.dialogVisible = false;
      this.$emit("cropperCancel");
    },
  },
};
</script>

<style scoped>
/* .cropper-content {
  width: auto;
  height: 450px;
} */
.cropper {
  width: 100%;
  height: 80vh;
}
</style>


// WEBPACK FOOTER //
// src/components/common/ImgCropper.vue